import { httpClient } from "../main";

export async function getProductList(data) {
  // console.log("getlist Data: " + JSON.stringify(data));
  return await httpClient.post("GetFilteredProducts?language=en", data);
}
